module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAIAAAC0D9CtAAAABnRSTlMA/wD/AP83WBt9AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAZElEQVR42mP8//8/A4mAiYF0MKqHgYEFmdPb24tLXXFxMZzNiBY/CxYskFdQRBZ5+OB+QkICPrclJCQcOngAzj108ACaBgYGBob/2EBDQ8O+/QcaGhqwymLXA9GGS4pxNL0xAACmfXk+0Mz1cQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// E:/Atlassian/bamboo-home/1/7766019/ESDE-EN172-JOB1/ng5/node_modules/jqwidgets-framework/jqwidgets/styles/images/sortdescbutton.png
// module id = ../../../../jqwidgets-framework/jqwidgets/styles/images/sortdescbutton.png
// module chunks = styles